module.exports = __webpack_public_path__ + "img/obs_snow_100.9f912a07.svg";